import React from 'react';
import { Stack, Text } from '@fluentui/react';
import { SecondsToMMSS } from 'components/util';

const timerStyle = { root: { minWidth: 186 } };

export interface ReviewTimerProps {
  timeLeftInSeconds: number;
}

export const ReviewTimer: React.FunctionComponent<ReviewTimerProps> = props => {
  return (
    <Stack.Item styles={timerStyle}>
      <Text variant="mediumPlus">
        Set returns to queue in: <b>{SecondsToMMSS(props.timeLeftInSeconds)}</b>
      </Text>
    </Stack.Item>
  );
};
